import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import{ GlobalConstants } from '../../common/global-constants';
import { UserService } from './user.service';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { DownloadModel } from '../models/download.model';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/Downloads";
  form : FormGroup = DownloadModel.getFormGroup();
  constructor(private http : HttpClient, private userservice : UserService) {
    this.BaseURI = window.location.origin + "/api";

  }

  populateForm (data){
    //ProductModel.populateForm(this.form, data);
    console.log("populateForm");
    this.form.setValue(data);
  }
  initializeFormGroup(category, subcategory, keyword)
  {
    DownloadModel.initializeFormGroup(this.form, category, subcategory, keyword);
    console.log("initializeFormGroup");
    //this.form.setValue().value.category = category;
    //this.form.value.subcategory = subcategory;
  }

  getData(id)
  {
    return this.http.get(this.BaseURI + this.apiController + "/" + id);
  }

  insertData(item : DownloadModel)
  {
     item.createBy = this.userservice.getUserID();
     return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["fileId", "createTime"]));
  }

  updateData(item : DownloadModel)
  {
     return this.http.put(this.BaseURI + this.apiController + "/" + item.fileId, item);
  }

  getList(category, subcategory, key)
  {
    return this.http.get(this.BaseURI + this.apiController + "/" + category + "/" + subcategory+ "/" + key);
  }

  deleteData(id)
  {
    return this.http.delete(this.BaseURI + this.apiController + "/" + id);

  }

}
